'use client';

/**
 * Stair Step Plan - Custom Layout
 * All components are specific to this plan only, kept in this folder.
 */

import { PlanIntroSection } from '../common/plan-intro-section';
import { FeaturesSection } from '../common/features-section';
import { WhySoftwareSection } from '../common/why-software-section';
import { HowSoftwareWorksSection } from '../common/how-software-works-section';
import { WhatIsSoftwareSection } from '../common/what-is-software-section';
import { CommissionsSection } from '../common/commissions-section';
import { AdvantagesSection } from '../common/advantages-section';
import { WhatIsPlanSection } from './WhatIsPlanSection';
import { HowItWorksSection } from './HowItWorksSection';
import { TrendingUp, Layers, Award, Target, DollarSign, Users } from 'lucide-react';

interface MLMPlan {
    slug: string;
    name: string;
    description: string;
    content: string;
    image?: string;
    features?: string[];
}

interface PlanDetailContentProps {
    plan: MLMPlan;
}

export default function PlanDetailContent({ plan }: PlanDetailContentProps) {
    return (
        <div className="min-h-screen bg-white dark:bg-gray-950">
            <PlanIntroSection
                plan={plan}
                translationNamespace="planDetails.stairStepPlan.hero"
                imageSrc="/images/mlm-plans/stairstep_animate.gif"
                descriptionKeys={['description1', 'description2']}
            />
            <WhatIsPlanSection plan={plan} />
            <HowItWorksSection plan={plan} />
            <WhatIsSoftwareSection
                plan={plan}
                translationNamespace="planDetails.stairStepPlan.whatIsSoftware"
                imageSrc="/images/mlm-plans/mlm-software-demo.webp"
            />
            <HowSoftwareWorksSection plan={plan} translationNamespace="planDetails.stairStepPlan.howSoftwareWorks" />
            <FeaturesSection plan={plan} translationNamespace="planDetails.stairStepPlan.features" />
            <AdvantagesSection
                plan={plan}
                translationNamespace="planDetails.stairStepPlan.advantages"
                advantageKeys={['advantage1', 'advantage2', 'advantage3', 'advantage4', 'advantage5', 'advantage6', 'advantage7', 'advantage8']}
                gridCols="3"
            />
            <CommissionsSection
                plan={plan}
                translationNamespace="planDetails.stairStepPlan.commissions"
                commissions={[
                    { icon: TrendingUp, color: 'primary', titleKey: 'step.title', descriptionKey: 'step.description' },
                    { icon: Layers, color: 'blue', titleKey: 'level.title', descriptionKey: 'level.description' },
                    { icon: Award, color: 'green', titleKey: 'rankAdvancement.title', descriptionKey: 'rankAdvancement.description' },
                    { icon: Target, color: 'purple', titleKey: 'performance.title', descriptionKey: 'performance.description' },
                    { icon: DollarSign, color: 'orange', titleKey: 'bonus.title', descriptionKey: 'bonus.description' },
                    { icon: Users, color: 'blue', titleKey: 'recruitment.title', descriptionKey: 'recruitment.description' },
                ]}
                gridCols="3"
            />
            <WhySoftwareSection plan={plan} translationNamespace="planDetails.stairStepPlan.whySoftware" />
        </div>
    );
}

